






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeDokter } from "@/store/modules/dokter";

interface AutocompleteOptions {
  outlined: boolean;
  label: string | null;
}

@Component({
  components: {}
})
export default class DokterAutoComplete extends Vue {
  @Prop() setDokter!: object;

  @Prop({
    default: () => {
      return {
        outlined: true,
        label: null
      };
    }
  })
  opt: AutocompleteOptions;

  get listDokter() {
    return storeDokter.listAll;
  }

  dokter = {};
  list = [];
  searchDokter = null;
  loading = false;
  validasi = [v => !!v || "*Kolom Dokter Harus Diisi"];

  @Watch("setDokter")
  valDokter(val) {
    this.$emit("dokter", val);
  }
}
